import { DeviceInfoDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderDeviceInfoDialog = mountDialogUIReactComponent(DeviceInfoDialog);
export function showDeviceInfoDialog(props) {
    renderDeviceInfoDialog(props);
}
